function getFilename(res) {
  const contentDisposition = res.headers['content-disposition'];
  const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;

  return contentDisposition.match(filenameRegex)[1];
}

export { getFilename };
